<div class="centered-content">
  <div class="card mb-4">
    <div class="card-header">
      <img src="assets/img/logo-artheau-transparent.png" height="40" /> <em>SIMPLY</em>fly
    </div>
    <div class="card-body">
      <h4 [innerText]="'AUTH.WELCOME' | translate"></h4>

      <p class="mb-4" [innerText]="'AUTH.PLEASE_LOGIN' | translate"></p>

      <form (ngSubmit)="submitForm()" [formGroup]="form" (keydown.enter)="submitForm()">
        <div class="form-group">
          <label class="form-label" [innerText]="'EMAIL' | translate"></label>
          <input
            tabindex="1"
            type="email"
            class="form-control"
            formControlName="email"
            placeholder="email@email.com"
            [class.is-invalid]="email.invalid && (email.dirty || email.touched)"
            />
          @if (email.dirty && email.errors) {
            <div class="invalid-tooltip">
              @if (email.errors && email.errors['required']) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
              @if (email.errors && email.errors['email']) {
                <div [innerText]="'FORM_VALIDATIONS.VALID_EMAIL' | translate"></div>
              }
            </div>
          }
        </div>

        <div class="form-group">
          <div class="d-flex justify-content-between">
            <label class="form-label" for="password" [innerText]="'AUTH.PASSWORD' | translate"></label>
            <a routerLink="/password-forgotten" tabindex="4">
              <small [innerText]="'AUTH.FORGOT_PASSWORD_TITLE' | translate"></small>
            </a>
          </div>
          <div class="input-group">
            <input
              tabindex="2"
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              [placeholder]="'AUTH.PASSWORD' | translate"
              formControlName="password"
                            [class.is-invalid]="
                                password.invalid && (password.dirty || password.touched)
                            "
              />
            <button class="btn" type="button" (click)="toggleType()" tabindex="3">
              @if (!showPassword) {
                <fa-icon [icon]="faEye"></fa-icon>
              }
              @if (showPassword) {
                <fa-icon [icon]="faEyeSlash"></fa-icon>
              }
            </button>
            @if (password.dirty && password.errors) {
              <div class="invalid-tooltip">
                @if (password.errors && password.errors['required']) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
                @if (password.errors && password.errors['minlength']) {
                  <div>
                    Ce champ doit faire au moins
                    {{ password.errors["minlength"]["requiredLength"] }}
                    caractères.
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <button
          class="w-100 btn btn-lg btn-primary mt-2"
          type="submit"
          [disabled]="form.disabled || !form.valid"
          (click)="submitForm()"
          tabindex="5"
          >
          {{ 'AUTH.LOGIN' | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
